import type { ApiResponse } from "@/types/apiResponse";
import { lsSelectedCompany, lsToken, storageName } from "@/constans/auth";


type HttpMethod = "GET" | "POST" | "PUT" | "PATCH" | "DELETE";

interface RequestConfig {
   method?: HttpMethod;
   body?: any;
   headers?: HeadersInit;
}

export async function apiClient<T>(
   endpoint: string,
   config: RequestConfig = {}
): Promise<T> {
   const { method = "GET", body } = config;
   let { headers = {} } = config;
   const token = localStorage.getItem(lsToken);
   if (token) {
      headers = { "Authorization": `Bearer ${token}`, ...headers };
   }
   const response = await fetch(`${API_HOST}${endpoint}`, {
      method,
      headers: {
         "Content-Type": "application/json",
         ...headers,
      },
      body: body ? JSON.stringify(body) : undefined,
   });
   // 🔥 Manejo global 401
   if (response.status === 401) {

      localStorage.removeItem(lsToken);
      localStorage.removeItem(storageName);
      localStorage.removeItem(lsSelectedCompany);

      // redirigir
      window.location.href = `${BASE_PATH}login`;

      throw { message: "Sesión expirada" } as ApiResponse;
   }
   if (response.status !== 200 && response.status !== 201) {
      let data = await response.json();
      throw { message: data.message || "Error" } as ApiResponse;
   }

   let data: ApiResponse;

   try {
      data = await response.json();
   } catch {
      throw { message: "Sesión expirada" } as ApiResponse;
   }
   if (!response.ok) {
      throw data;
   }

   return data as T;
}
